<template>
  <div class="game-by-unity">
    <iframe
      allow="fullscreen"
      :src="gameUrl"
      frameborder="0"
    />
    <!-- 左上角按钮 -->
    <div class="btn-group">
      <button
        class="return-home"
        :style="{
          backgroundImage: `url(${returnHomeBtnBgImgUrl})`,
        }"
        @click="onClickReturnHome"
      />
      <button
        v-if="store.state.gameRuleList[gameRuleConfig.idxInGameRule].rtf"
        class="game-rule"
        :style="{
          backgroundImage: `url(${gameRuleBtnBgImgUrl})`,
        }"
        @click="isShowRule = true"
      />
    </div>

    <transition name="fade-out">
      <NotifyComp
        v-if="isShowNotifyBonusPointReachedLimit"
        text="已达本日积分上限"
      />
    </transition>

    <GameRule
      v-show="isShowRule"
      :game-title="gameRuleConfig.title"
      :rich-text="store.state.gameRuleList[gameRuleConfig.idxInGameRule].rtf"
      @close="isShowRule=false"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"
import GameRule from '@/components/GameRule.vue'
import { onBeforeUnmount } from "vue"
import { notifyQuit } from '@/api.js'
import NotifyComp from '@/components/NotifyComp.vue'

const route = useRoute()
const router = useRouter()
const store = useStore()

const {
  windowSizeInCssForRef,
  windowSizeWhenDesignForRef,
} = useSizeAdapt(390, 752)

let gameUrlQuery = ''
if (store.state.loginStatus) {
  gameUrlQuery = `?userId=${store.state.userInfo.id}&token=${store.state.token}`
}
const gameUrlMap = {
  AntibodyBattle: `unity/antibody-battle/index.html${gameUrlQuery}#/`,
  DisasterRelief: `unity/disaster-relief/index.html${gameUrlQuery}#/`,
  EnviromentProtection: `unity/enviroment-protection/index.html${gameUrlQuery}#/`,
  LostChildren: `unity/lost-children/index.html${gameUrlQuery}#/`,
}
const gameUrl = gameUrlMap[route.query.gameName]

const floatingBtnFileNameAffixMap = {
  AntibodyBattle: ``,
  DisasterRelief: ``,
  EnviromentProtection: ``,
  LostChildren: `_dark`,
}
const floatingBtnFileNameAffix = floatingBtnFileNameAffixMap[route.query.gameName]
const returnHomeBtnBgImgUrl = require(`@/assets/images/icon_home${floatingBtnFileNameAffix}.png`)
const gameRuleBtnBgImgUrl = require(`@/assets/images/icon_rules${floatingBtnFileNameAffix}.png`)

function onClickReturnHome() {
  if (store.state.isDirectPlayGame) {
    notifyQuit()
  } else {
    router.push({
      name: 'HomeView',
    })
  }
}

const gameRuleConfigMap = {
  AntibodyBattle: {
    title: '一起来作战',
    idxInGameRule: 3,
  },
  DisasterRelief: {
    title: '一起来救灾',
    idxInGameRule: 4,
  },
  EnviromentProtection: {
    title: '一起来清理',
    idxInGameRule: 5,
  },
  LostChildren: {
    title: '一起找儿童',
    idxInGameRule: 6,
  },
}
const gameRuleConfig = gameRuleConfigMap[route.query.gameName]
const isShowRule = ref(false)

const isShowNotifyBonusPointReachedLimit = ref(false)
if (store.state.ifScoreLimitReached) {
  isShowNotifyBonusPointReachedLimit.value = true
  setTimeout(() => {
    isShowNotifyBonusPointReachedLimit.value = false
  }, 2000)
}

document.querySelector('#app > .top-wrapper').style.width = '100%'
onBeforeUnmount(() => {
  document.querySelector('#app > .top-wrapper').style.width = ''
})
</script>

<style lang="less" scoped>
.game-by-unity{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  >iframe{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  >.btn-group{
    position: absolute;
    top: calc(36 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    right: calc(12 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    display: flex;
    flex-direction: column;
    gap: calc(16 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    >button.return-home{
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      width: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      height: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    }
    >button.game-rule{
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      width: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      height: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    }
  }
}
</style>